// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/modules/components/jobdetails-rs.less
// module id = 411
// module chunks = 0